module.exports = __webpack_public_path__ + "static/5-736ab2ab59a03a72eaccc963bdae5981.jpg";